var chunkMapping = {
	"124": [
		20124
	],
	"276": [
		95276
	],
	"412": [
		99412
	],
	"449": [
		31449
	],
	"507": [
		12507
	],
	"696": [
		62696
	]
};
var idToExternalAndNameMapping = {
	"12507": [
		"default",
		"./App",
		22575
	],
	"20124": [
		"default",
		"./App",
		45659
	],
	"31449": [
		"default",
		"./App",
		47498
	],
	"62696": [
		"default",
		"./App",
		53510
	],
	"95276": [
		"default",
		"./Widget",
		47498
	],
	"99412": [
		"default",
		"./UpsellWidget",
		53510
	]
};
var idToRemoteMap = {
	"12507": [
		{
			"externalType": "script",
			"name": "user_management_frontend"
		}
	],
	"20124": [
		{
			"externalType": "script",
			"name": "poiManagement"
		}
	],
	"31449": [
		{
			"externalType": "script",
			"name": "wizardGenerator"
		}
	],
	"62696": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer"
		}
	],
	"95276": [
		{
			"externalType": "script",
			"name": "wizardGenerator"
		}
	],
	"99412": [
		{
			"externalType": "script",
			"name": "dashboardGeneratorVisualizer"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"12507": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 22575,
		"remoteName": "user_management_frontend"
	},
	"20124": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 45659,
		"remoteName": "poiManagement"
	},
	"31449": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 47498,
		"remoteName": "wizardGenerator"
	},
	"62696": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 53510,
		"remoteName": "dashboardGeneratorVisualizer"
	},
	"95276": {
		"shareScope": "default",
		"name": "./Widget",
		"externalModuleId": 47498,
		"remoteName": "wizardGenerator"
	},
	"99412": {
		"shareScope": "default",
		"name": "./UpsellWidget",
		"externalModuleId": 53510,
		"remoteName": "dashboardGeneratorVisualizer"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}